import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Share2, Download, CheckCircle } from 'lucide-react';
import { TicketQR } from '../components/TicketQR';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
export function ETicketPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#006a4e] pb-24 relative" data-id="element-155">
      {/* Success Header */}
      <div className="pt-12 pb-24 px-6 text-center text-white" data-id="element-156">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm" data-id="element-157">
          <CheckCircle size={32} className="text-white" data-id="element-158" />
        </div>
        <h1 className="text-2xl font-bold font-bengali" data-id="element-159">বুকিং সফল হয়েছে!</h1>
        <p className="text-green-100 font-bengali mt-2" data-id="element-160">আপনার ই-টিকিট তৈরি</p>
      </div>

      {/* Ticket Card */}
      <div className="px-4 -mt-16" data-id="element-161">
        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-162">
          <div className="p-6 border-b border-dashed border-gray-300 relative" data-id="element-163">
            {/* Cutout circles */}
            <div className="absolute -left-3 bottom-[-12px] w-6 h-6 bg-[#006a4e] rounded-full" data-id="element-164" />
            <div className="absolute -right-3 bottom-[-12px] w-6 h-6 bg-[#006a4e] rounded-full" data-id="element-165" />

            <div className="text-center mb-6" data-id="element-166">
              <p className="text-gray-500 text-sm font-bengali" data-id="element-167">
                এম ভি কর্ণফুলী ১০
              </p>
              <div className="flex items-center justify-center space-x-4 mt-2" data-id="element-168">
                <div className="text-right" data-id="element-169">
                  <p className="text-2xl font-bold text-gray-900 font-bengali" data-id="element-170">
                    ০৮:০০
                  </p>
                  <p className="text-xs text-gray-500 font-bengali" data-id="element-171">সদরঘাট</p>
                </div>
                <div className="text-gray-300" data-id="element-172">➝</div>
                <div className="text-left" data-id="element-173">
                  <p className="text-2xl font-bold text-gray-900 font-bengali" data-id="element-174">
                    ১২:৩০
                  </p>
                  <p className="text-xs text-gray-500 font-bengali" data-id="element-175">ভোলা</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-xl" data-id="element-176">
              <div data-id="element-177">
                <p className="text-xs text-gray-500 font-bengali" data-id="element-178">তারিখ</p>
                <p className="font-bold font-bengali text-gray-900" data-id="element-179">
                  ১৫ মার্চ, ২০২৪
                </p>
              </div>
              <div data-id="element-180">
                <p className="text-xs text-gray-500 font-bengali" data-id="element-181">সিট</p>
                <p className="font-bold font-bengali text-gray-900" data-id="element-182">
                  ডেক - বি৩৫
                </p>
              </div>
            </div>
          </div>

          <div className="p-6 flex flex-col items-center" data-id="element-183">
            <TicketQR data-id="element-184" />
            <div className="flex space-x-4 mt-8 w-full" data-id="element-185">
              <button className="flex-1 py-3 border border-gray-200 rounded-xl flex items-center justify-center space-x-2 text-gray-700 font-bold font-bengali hover:bg-gray-50" data-id="element-186">
                <Share2 size={18} data-id="element-187" />
                <span data-id="element-188">শেয়ার</span>
              </button>
              <button className="flex-1 py-3 bg-[#006a4e] text-white rounded-xl flex items-center justify-center space-x-2 font-bold font-bengali hover:bg-[#004d38]" data-id="element-189">
                <Download size={18} data-id="element-190" />
                <span data-id="element-191">ডাউনলোড</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 mt-8" data-id="element-192">
        <button onClick={() => navigate('/home')} className="w-full bg-white/10 text-white py-4 rounded-xl font-bold text-lg font-bengali flex items-center justify-center space-x-2 backdrop-blur-sm border border-white/20" data-id="element-193">
          <Home size={20} data-id="element-194" />
          <span data-id="element-195">হোমে ফিরে যান</span>
        </button>
      </div>
    </div>;
}